(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8130],{

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 51584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 97585:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scientific-collaboration-program",
      function () {
        return __webpack_require__(78588);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useMods__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19531);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




var AccordionBody = function(param) {
    var children = param.children, mods = param.mods, classNameTail = param.className;
    var className = (0,_hooks_useMods__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(AccordionBody, {
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: children
    });
};
AccordionBody.displayName = "Accordion__Body";
AccordionBody.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
    mods: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object)
};
AccordionBody.defaultProps = {
    mods: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionBody);


/***/ }),

/***/ 57504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useMods__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19531);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);







var TIMEOUT = 250;
var transitionStyles = {
    entering: {
        maxHeight: "100%",
        transition: "max-height ".concat(TIMEOUT, "ms")
    },
    entered: {
        maxHeight: 0
    },
    exiting: {
        transition: "max-height ".concat(TIMEOUT, "ms"),
        maxHeight: "100%"
    }
};
var AccordionCollapse = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, collapsed = param.collapsed;
    var className = (0,_hooks_useMods__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(AccordionCollapse, {
        mix: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, mix), {
            collapsed: collapsed
        }),
        mods: mods
    }, true).className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: children
    });
};
AccordionCollapse.displayName = "Accordion__Collapse";
AccordionCollapse.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node),
    isAcitve: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    mix: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().object),
    mods: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().object)
};
AccordionCollapse.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionCollapse);


/***/ }),

/***/ 41412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useMods__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19531);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




var AccordionHeader = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, onClick = param.onClick, classNameTail = param.className;
    var className = (0,_hooks_useMods__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(AccordionHeader, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        className: className + (classNameTail ? " " + classNameTail : ""),
        onClick: onClick,
        children: children
    });
};
AccordionHeader.displayName = "Accordion__Header";
AccordionHeader.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
    mix: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
    mods: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().func)
};
AccordionHeader.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionHeader);


/***/ }),

/***/ 93214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useMods__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19531);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




var AccordionItem = function(param) {
    var children = param.children, mods = param.mods, classNameTail = param.className;
    var className = (0,_hooks_useMods__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(AccordionItem, {
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: children
    });
};
AccordionItem.displayName = "Accordion__Item";
AccordionItem.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().node),
    mods: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object)
};
AccordionItem.defaultProps = {
    mods: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (AccordionItem);


/***/ }),

/***/ 1686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Card/CardBody.jsx




var CardBody = function(param) {
    var textTop = param.textTop, title = param.title, text = param.text, mods = param.mods, mix = param.mix;
    var className = (0,useMods/* default */.Z)(CardBody, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            textTop,
            title,
            text
        ]
    });
};
CardBody.displayName = "Card__Body";
CardBody.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    text: (prop_types_default()).object,
    textTop: (prop_types_default()).object,
    title: (prop_types_default()).object
};
CardBody.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Card_CardBody = (CardBody);

;// CONCATENATED MODULE: ./src/components/Card/CardFooter.jsx




var CardFooter = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix;
    var className = (0,useMods/* default */.Z)(CardFooter, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: children
    });
};
CardFooter.displayName = "Card__Footer";
CardFooter.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
CardFooter.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Card_CardFooter = (CardFooter);

;// CONCATENATED MODULE: ./src/components/Card/Card.jsx







var Card = function(param) {
    var image = param.image, imageBottom = param.imageBottom, body = param.body, footer = param.footer, mods = param.mods, mix = param.mix, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Card, {
        mix: mix,
        mods: (0,_object_spread/* default */.Z)({}, mods)
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: [
            image,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardBody, {
                title: body.title,
                textTop: body.textTop,
                text: body.text
            }),
            imageBottom,
            footer && /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_CardFooter, {
                children: footer
            })
        ]
    });
};
Card.displayName = "Card";
Card.propTypes = {
    body: (prop_types_default()).object,
    footer: (prop_types_default()).node,
    image: (prop_types_default()).node,
    imageBottom: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    title: (prop_types_default()).node
};
Card.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Card_Card = (Card);

;// CONCATENATED MODULE: ./src/components/Card/index.js

/* harmony default export */ var components_Card = (Card_Card);


/***/ }),

/***/ 20244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Hero/Hero.jsx




var Hero = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Hero, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: children
    });
};
Hero.displayName = "Hero";
Hero.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
Hero.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Hero_Hero = (Hero);

;// CONCATENATED MODULE: ./src/components/Hero/index.js

/* harmony default export */ var components_Hero = (Hero_Hero);


/***/ }),

/***/ 78588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ scientific_collaboration_program; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/layouts/Layout/index.js + 16 modules
var Layout = __webpack_require__(65305);
// EXTERNAL MODULE: ./src/layouts/Navigation/Traqq/index.js + 2 modules
var Traqq = __webpack_require__(94665);
// EXTERNAL MODULE: ./src/components/Hero/index.js + 1 modules
var Hero = __webpack_require__(20244);
// EXTERNAL MODULE: ./src/components/Info/index.js + 1 modules
var Info = __webpack_require__(54491);
// EXTERNAL MODULE: ./src/components/UI/Container/index.js + 1 modules
var Container = __webpack_require__(76956);
// EXTERNAL MODULE: ./src/components/UI/Icon/index.js + 3 modules
var Icon = __webpack_require__(60726);
// EXTERNAL MODULE: ./src/components/UI/Link/index.js + 1 modules
var Link = __webpack_require__(57202);
// EXTERNAL MODULE: ./src/components/UI/Picture/index.js + 1 modules
var Picture = __webpack_require__(85593);
// EXTERNAL MODULE: ./src/components/UI/Typography/Heading/index.js + 1 modules
var Heading = __webpack_require__(70408);
// EXTERNAL MODULE: ./src/components/UI/Typography/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(39466);
// EXTERNAL MODULE: ./src/components/Card/index.js + 3 modules
var Card = __webpack_require__(1686);
// EXTERNAL MODULE: ./src/components/Grid/index.js + 1 modules
var Grid = __webpack_require__(4711);
// EXTERNAL MODULE: ./src/screens/Home/data.js + 19 modules
var data = __webpack_require__(9207);
// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
;// CONCATENATED MODULE: ./src/assets/Images/pie-chart.png
/* harmony default export */ var pie_chart = ({"src":"/_next/static/media/pie-chart.c087f548.png","height":120,"width":120,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABB0lEQVR42j2PT0sCQRxA5+O0fpvK7RJ9ACmqQ4cuGQnZX6NLSYVtCBXB7CxSl8h2RlsKatldd1rLwWLVQxBtf0jH4y8K813fuzz0y8mLPVAqOuZrUZdHa1zupgNWOmvE/mSHdBTDEm/Hlg0takJ+0YPlcRd2Fnh0aYQKujcr9BE/QPn2OayL6tB5XqjZeb+ZmXJBWwkoWuK2zDkO+F5rGPUgOaFuzniQTfpdtG6FUruugsvv4v+BsS9G+sETxfQdT8KXPtGQ5Q31igTx7SRvZqYd0FYDhoDNKp84EUWHo9DGg3BzcAGpBIe9VCUyC72Tb1uPfZzOsTYZ69Z0IrfSdWYVagpCCP0AoZGgYsaXMB8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/Images/kaggle-logo.png
/* harmony default export */ var kaggle_logo = ({"src":"/_next/static/media/kaggle-logo.0272a78f.png","height":120,"width":204,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAWElEQVR42mNQ2PePhQEfACrwVtj7TxqIFYBYE4gVgGKuQGwLZIuDFHQCcQkQLwTiKiBuBuIWIF4GxLkgBaJArA7EukCcAcRJQBwPxDJALIVuHTcQcyK7CwAvLzuKP6h3dwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/assets/Images/hf-logo.png
/* harmony default export */ var hf_logo = ({"src":"/_next/static/media/hf-logo.7729a78a.png","height":120,"width":120,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA00lEQVR42mWNP0tCYRjFn1tjS1v1NYoIGqMvEPQFmpqroYRoaoiG2mtsioZGEZTXPyjiBV8RrooKgs7q4FWuXnx+gl5x8AdnOOdwOBKAIxEe7Erkt6D+94yNtai8NGgm7paZiLMqvd/YJHdJ4Ap+UZgWrqFtbjdr+2QHGaFnjmed5Ml0nBeofpplOYc9so9NjOB+nIfe91lIWtDCexnYEbq1C01doRmBSGoEzA067J+KjsYHVL7iau/9eenN1dJrGfvgU/35V9iXNRpwFF06hByu8wVvDofQlg3RnQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/screens/ScientificCollaborationProgram/data.js





/* harmony default export */ var ScientificCollaborationProgram_data = ({
    features: [
        {
            alt: "Employee time tracking - Traqq",
            id: 1,
            icon: {
                name: "timer"
            },
            title: "Time tracking"
        },
        {
            alt: "Employee activity tracking - Traqq",
            id: 2,
            icon: {
                name: "monitoring"
            },
            title: "Activity tracking"
        },
        {
            alt: "Websites usage monitoring - Traqq",
            id: 3,
            icon: {
                name: "globe"
            },
            title: "Websites usage monitoring"
        },
        {
            alt: "Computer programs usage monitoring - Traqq",
            id: 4,
            icon: {
                name: "app"
            },
            title: "Computer programs usage monitoring"
        },
        {
            alt: "Billable hours calculation - Traqq",
            id: 5,
            icon: {
                name: "check"
            },
            title: "Billable hours calculation"
        },
        {
            alt: "Attendance tracking - Traqq",
            id: 6,
            icon: {
                name: "attendance"
            },
            title: "Attendance tracking"
        },
        {
            alt: "Dashboard and data visualization - Traqq",
            id: 7,
            icon: {
                name: "chart"
            },
            title: "Dashboard and data visualization"
        },
        {
            alt: "Easily exportable tabular data - Traqq",
            id: 8,
            icon: {
                name: "export-1"
            },
            title: "Easily exportable tabular data"
        }
    ],
    cards: [
        {
            alt: "Kaggle community",
            desc: "Kaggle community",
            id: 1,
            image: kaggle_logo,
            title: "Kaggle community",
            url: "https://www.kaggle.com/traqqteam/datasets"
        },
        {
            alt: "Hugging Face community",
            desc: "Hugging Face community",
            id: 2,
            image: hf_logo,
            title: "Hugging Face community",
            url: "https://huggingface.co/traqq"
        },
        {
            alt: "Time management statistics - Traqq",
            desc: "Time management statistics",
            id: 3,
            image: pie_chart,
            title: "Time management statistics",
            url: "https://traqq.com/blog/category/time-management-statistics/"
        }
    ],
    faq: [
        {
            desc: "Traqq offers academic and research institutions all premium features on a free basis for the period of six months to conduct their research.",
            id: 1,
            title: "Which resources does Traqq provide to educational and research institutions during scientific collaboration?"
        },
        {
            desc: "Universities can collect and utilize various types of data, including:",
            list: [
                "Time tracking insights",
                "Application usage",
                "Website visits",
                "Activity data",
                "Clock-in and clock-out times",
                "Time spent on tasks",
                "Activity Breakdown",
                "Work pattern",
                "Project timeline",
                "Collaboration data",
                "Resource allocation",
                "Engagement levels",
                "Trends over time",
                "Time utilization",
                "Absenteeism and punctuality",
                "Break and downtime analysis",
                "Impact of interventions",
                "Individual and group performance metrics"
            ],
            id: 2,
            title: "What kind of valuable scientific data can these institutions obtain through scientific collaboration?"
        },
        {
            desc: "The Traqq team is willing to discuss the possibility of providing an API for educational and research teams on an individual basis.",
            id: 3,
            title: "Does Traqq offer an API for scientific collaboration?"
        }
    ]
});

;// CONCATENATED MODULE: ./src/screens/ScientificCollaborationProgram/Hero.jsx















var PageHero = function() {
    var features = ScientificCollaborationProgram_data.features;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
        mods: {
            home: true
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info/* default */.Z, {
                    mods: {
                        center: true
                    },
                    className: (0,css/* default */.Z)("max-w-[996px] mx-auto"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                            tag: "h1",
                            children: [
                                "Traqq ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-violet-700",
                                    children: "Scientific Collaboration"
                                }),
                                " Program"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                            tag: "p",
                            size: "lg",
                            className: (0,css/* default */.Z)("!leading-32p max-w-[840px]"),
                            children: "Traqq welcomes the opportunity to engage in scientific research projects and offer academic and research institutions diverse workforce tracking data solutions. Through our innovative tools, we aim to support institutions in analyzing work patterns and productivity, ultimately contributing valuable insights to the field of human behavior."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    xs: 1,
                    mods: {
                        shadow: true
                    },
                    className: "p-6 mt-12 rounded-16p",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                        xs: 2,
                        lg: 4,
                        gx: 6,
                        gy: 10,
                        mods: {
                            bordered: true
                        },
                        children: features.map(function(item) {
                            var ref, ref1;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-violet-100 rounded-lg w-12 h-12 flex items-center justify-center",
                                        children: ((ref = item.icon) === null || ref === void 0 ? void 0 : ref.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            name: (ref1 = item.icon) === null || ref1 === void 0 ? void 0 : ref1.name,
                                            color: "violet-700",
                                            size: 24
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "heading h7",
                                        children: item.title
                                    })
                                ]
                            }, item.id);
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ScientificCollaborationProgram_Hero = (PageHero);

// EXTERNAL MODULE: ./src/components/Section/index.js + 2 modules
var Section = __webpack_require__(62091);
// EXTERNAL MODULE: ./src/components/UI/Button/index.js + 1 modules
var Button = __webpack_require__(92317);
;// CONCATENATED MODULE: ./src/screens/ScientificCollaborationProgram/Cards.jsx













var Cards = function() {
    var cards = ScientificCollaborationProgram_data.cards;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        mods: {
            home: true
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeadline */.A, {
                    mods: {
                        center: true
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                        tag: "h2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-violet-700",
                                children: "Time tracking"
                            }),
                            " data"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    xs: 1,
                    md: 3,
                    gx: 6,
                    gy: 10,
                    children: cards.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                            mods: {
                                shadow: true,
                                hover: true,
                                "text-block": true
                            },
                            className: "p-6",
                            image: /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                                image: item.image,
                                alt: item.alt,
                                sizes: "(min-width: 1024px) 25vw, (min-width: 768px) 30vw, (min-width: 425px) 50vw, 50vw",
                                props: {
                                    height: 60
                                },
                                mods: {
                                    centered: false
                                },
                                className: "pb-4"
                            }),
                            body: {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "heading h6",
                                    children: item.title
                                })
                            },
                            footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: item.url,
                                mods: {
                                    stretched: true
                                },
                                linkProps: {
                                    "title": item.title
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "hidden",
                                    children: item.title
                                })
                            })
                        }, item.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ScientificCollaborationProgram_Cards = (Cards);

// EXTERNAL MODULE: ./src/components/Accordion/AccordionBody.jsx
var AccordionBody = __webpack_require__(10522);
// EXTERNAL MODULE: ./src/components/Accordion/AccordionCollapse.jsx
var AccordionCollapse = __webpack_require__(57504);
// EXTERNAL MODULE: ./src/components/Accordion/AccordionHeader.jsx
var AccordionHeader = __webpack_require__(41412);
// EXTERNAL MODULE: ./src/components/Accordion/AccordionItem.jsx
var AccordionItem = __webpack_require__(93214);
// EXTERNAL MODULE: ./src/components/List/index.js + 2 modules
var List = __webpack_require__(71285);
;// CONCATENATED MODULE: ./src/screens/ScientificCollaborationProgram/FAQ.jsx















var Faq = function() {
    var faq = ScientificCollaborationProgram_data.faq;
    var ref = (0,react.useState)(false), collapsed = ref[0], setCollapse = ref[1];
    var handleActiveClick = function(id) {
        setCollapse(id !== collapsed && id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        mods: {
            home: true,
            narrow: true
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionHeadline */.A, {
                    mods: {
                        center: true,
                        w: 75
                    },
                    gap: 4,
                    className: "relative lg:w-[75%]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        tag: "h2",
                        children: "Frequently Asked Questions"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col gap-y-4 max-w-[720px] mx-auto",
                    children: faq.map(function(param) {
                        var id = param.id, title = param.title, desc = param.desc, list = param.list;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionItem/* default */.Z, {
                            className: "!bg-transparent px-0 py-0 border-none",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionHeader/* default */.Z, {
                                    className: "!px-0 !pt-0 !pb-0 items-center !gap-0 !justify-start",
                                    onClick: function() {
                                        return handleActiveClick(id);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            name: collapsed === id ? "minus" : "plus",
                                            size: 40,
                                            color: "violet-700",
                                            className: "pr-4"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                                            mods: {
                                                row: true
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                                tag: "h5",
                                                children: title
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionCollapse/* default */.Z, {
                                    collapsed: collapsed === id || false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AccordionBody/* default */.Z, {
                                        className: "!pb-0 pt-2 !pr-10 !pl-14 text-neutral-700",
                                        children: [
                                            desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                mods: {
                                                    lg: true
                                                },
                                                color: "neutral_700",
                                                children: desc
                                            }),
                                            list && /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* List */.a, {
                                                gap: 2,
                                                className: "mt-4",
                                                children: list.map(function(desc, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* ListItem */.H, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                                name: "square-rounded",
                                                                color: "violet-700",
                                                                size: 24
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                                                                tag: "p",
                                                                size: "lg-custom",
                                                                color: "neutral_700",
                                                                children: desc
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var FAQ = (Faq);

;// CONCATENATED MODULE: ./src/assets/Images/handshake.png
/* harmony default export */ var handshake = ({"src":"/_next/static/media/handshake.aa9a0ef2.png","height":48,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA1klEQVR42mPABf4/sGQGM+53CbO8mcvA9vOEttKvC96JPy8FRqCo/LZPNufXCdmXv86YfPl90e3/n2vB//9e8zj+94LWvn8XVCMZvuyWOv73nPr/v1dc/vy/E/7r72X733/O6f//dVzp/9fdkscYni9kkPl2SH3dj1P2/39eDPz/76bvzz9nDf9/2ipy7NUiXiO4VT9PGs/+ftT4/89Txv//nNa4+eMAnwRY4uNWKWa4omMGSj+PKgV938PAC+J/2SHBCpb4tJmB8f+DcCYGJPDjgDRYIwB70WpoGE6n3AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
;// CONCATENATED MODULE: ./src/screens/ScientificCollaborationProgram/FeedbackBanner.jsx











var FeedbackBanner = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        mods: {
            home: true
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info/* default */.Z, {
                mods: {
                    center: true
                },
                className: (0,css/* default */.Z)("relative flex flex-col gap-4 justify-center text-center p-8 md:p-12 xl:p-16"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "absolute left-0 top-0 h-full w-full overflow-hidden -z-[1] rounded-16p",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "radials radials_dark w-[1716px] h-[1716px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "radials radials_dark w-[960px] h-[960px]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "radials radials_dark w-[600px] h-[600px]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        className: "heading heading_white h3 flex justify-center items-center gap-2.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "Let’s ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-violet-700",
                                        children: "make science"
                                    }),
                                    " together!"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: handshake,
                                alt: "Make science together",
                                width: 44,
                                height: 44
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                        color: "white",
                        mods: {
                            lg: true
                        },
                        className: "max-w-[568px]",
                        children: "Cooperation in science is essential for technological progress and understanding human behavior, ultimately enhancing our lives. The Traqq team is committed to scientific collaboration and eager to contribute to human resource management."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,css/* default */.Z)("flex flex-col gap-4 items-start justify-center"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            tag: "a",
                            type: "link",
                            href: "/contact?subject=Let%E2%80%99s%20make%20science%20together",
                            variant: "primary",
                            size: "lg",
                            mods: {
                                "no-spacing": true
                            },
                            className: "self-center",
                            children: "Collaborate with Traqq"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ScientificCollaborationProgram_FeedbackBanner = (FeedbackBanner);

;// CONCATENATED MODULE: ./src/screens/ScientificCollaborationProgram/ScientificCollaborationProgram.jsx







var ScientificCollaborationProgram = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Traqq/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScientificCollaborationProgram_Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScientificCollaborationProgram_Cards, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQ, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScientificCollaborationProgram_FeedbackBanner, {})
        ]
    });
};
/* harmony default export */ var ScientificCollaborationProgram_ScientificCollaborationProgram = (ScientificCollaborationProgram);

;// CONCATENATED MODULE: ./src/screens/ScientificCollaborationProgram/index.js

/* harmony default export */ var screens_ScientificCollaborationProgram = (ScientificCollaborationProgram_ScientificCollaborationProgram);

;// CONCATENATED MODULE: ./src/pages/scientific-collaboration-program.js




var title = "Traqq Scientific Collaboration Program";
var description = "The Traqq scientific collaboration program aims to unite academic needs with its powerful time management tools to contribute to science.";
var ScientificCollaborationPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        title: title,
        description: description,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(screens_ScientificCollaborationProgram, {})
    });
};
/* harmony default export */ var scientific_collaboration_program = (/*#__PURE__*/(0,react.memo)(ScientificCollaborationPage));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5646,1608,5555,4665,1295,9207,9774,2888,179], function() { return __webpack_exec__(97585); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);